import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { isLocal, hostName } from '../../../constants/apiEnv';
import WorkorderStyles from '../../noise_log/forms.module.scss';
import Loading from '../../../components/loading/loading';
import Panel from '../../../components/panel/Panel';
import Button from '../../../components/button/button';
import styles from '../create/fixedFields.module.scss';
import FormSubmitted from '../../forms/components/FormSubmitted';

const url = hostName.slice(6);
class MaintenanceCreatePublic extends Component {
     constructor(props) {
    super(props);
    this.state = {
        info: {
            comment: '',
            rating: '',
            smiley: '',
            module_type: 'NAWO'
        },
        showFormErrors: false,
        loadingStatus: false,
        apiStatus: undefined,
        hoveredStar: null,
        ratingError: '',
        commentError: '',
        customFeedbackMessage: ''

    };
      const { match: { params: { installationId } } } = props;
      this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${installationId}${url}/public`;
    }

    async componentDidMount() {
        const { match: { params: { airportCode } } } = this.props;
        try {
            this.setState({ loadingStatus: true });
            await fetch(`${this.publicUrl}/non_airfield/get_schema/${airportCode}`)
                .then(response => response.json())
                .then((data) => {
                this.setState({
                    leaseMaintenance_schema: data,
                    loadingStatus: false,
                    apiStatus: false
                });
                });
        } catch (e) {
            let message = 'There was a problem while retrieving the form';
            this.setState({
                message,
                apiStatus: true,
                loadingStatus: false
            });
        }
    }

    setCustomFeedbackMessage = (value) => {
        const { leaseMaintenance_schema } = this.state;
        const isRatingFeedback = leaseMaintenance_schema?.feedback_selection?.label === 'Rating';
        let customMessage = '';
        if (value === 1) {
            customMessage = isRatingFeedback
                ? "We're sorry you had a bad experience. Please tell us how we can improve."
                : "We're sorry to hear that! Please tell us how we can improve.";
        } else if (value === 2) {
            customMessage = isRatingFeedback
                ? 'We appreciate your honesty. Please let us know what could be better.'
                : 'We appreciate your honesty! Please share how we can make things better.';
        } else {
            customMessage = '';
        }
        this.setState({ customFeedbackMessage: customMessage });
    };

    handleAnswerChanged = (section, answer, fieldId) => {
        this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
        }));
    }

    handleFieldErrorChanged = (id, value) => {
        this.setState(prevState => ({
        fieldErrors: {
            ...prevState.fieldErrors,
            [id]: value
        }
        }));
    }

    handleReview = (value) => {
    const { info } = this.state;
    this.setCustomFeedbackMessage(value);
    if (value) {
        this.setState({
            info: {
                ...info,
                smiley: value
            },
            ratingError: ''
        });
    }
  }


create = async () => {
    const { match: { params: { airportCode, id } } } = this.props;
    const { info, leaseMaintenance_schema } = this.state;
    const isRatingFeedback = leaseMaintenance_schema?.feedback_selection?.label === 'Rating';

    // If API expects star rating, use rating, else use smiley
    const selectedValue = isRatingFeedback ? info.rating : info.smiley;

    // Show correct validation message
    const ratingErrorMessage = isRatingFeedback
        ? 'Please select a star rating to continue.'
        : 'Please select a smiley to rate your experience.';

    const commentErrorMessage = isRatingFeedback
        ? 'Please provide a comment for star ratings less than 3.'
        : 'Please provide a comment for smiley ratings less than 3.';

    // Validate selection
    if (!selectedValue) {
        this.setState({ ratingError: ratingErrorMessage });
        return;
    }
    this.setState({ ratingError: '' });

    // Validate comment if rating is less than 3
    if (Number(selectedValue) < 3 && !info.comment.trim()) {
        this.setState({ commentError: commentErrorMessage });
        return;
    }
    this.setState({ commentError: '' });

    // Prepare data
    const data = {
        comment: info?.comment,
        rating_smiley: Number(selectedValue),
        module_type: 'NAWO'
    };

    try {
        await fetch(`${this.publicUrl}/non_airfield/create_feedback_request/${id}/${airportCode}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        })
        .then(response => response.json())
        .then(() => {
            this.setState({
                message: 'Your feedback has been submitted successfully.',
                apiStatus: true,
                loadingStatus: false
            });
        });
    } catch (error) {
        let message = 'There was a problem while submitting the form';
        if (error && error.detail) message = error.detail;
        this.setState({
            message,
            apiStatus: true,
            loadingStatus: false
        });
    }
};

renderStarRating = () => {
    const { info, hoveredStar } = this.state;

    return (
        <div className={styles.starContainer}>
            {[1, 2, 3, 4, 5].map(star => (
        <span
            key={star}
            role="button"
            tabIndex={0}
            aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
            className={`${styles.star} ${star <= (hoveredStar !== null ? hoveredStar : parseInt(info.rating, 10) || 0) ? styles.filled : ''}`}
            onMouseEnter={() => this.setState({ hoveredStar: star })}
            onMouseLeave={() => this.setState({ hoveredStar: null })}
            onClick={() => {
                this.handleAnswerChanged('info', star, 'rating');
                this.setCustomFeedbackMessage(star);
                this.setState({ ratingError: '' });
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    this.handleAnswerChanged('info', star, 'rating');
                    this.setCustomFeedbackMessage(star);
                    this.setState({ ratingError: '' });
                }
            }}
            style={{ cursor: 'pointer', fontSize: '5rem' }}
        >
            ★
        </span>

            ))}
        </div>
    );
};

    render() {
        const { loadingStatus, leaseMaintenance_schema, info, message, apiStatus,
            ratingError, customFeedbackMessage } = this.state;
        return (
            <>
                {loadingStatus && (<Loading loadingStatus={loadingStatus} />)}
                {!apiStatus && leaseMaintenance_schema && Object.keys(leaseMaintenance_schema).length > 0 && (
                <>
                <div className={`${WorkorderStyles.title} ${WorkorderStyles.imgTitle}`}>
                    <img src={leaseMaintenance_schema?.airport_data?.image} alt="" />
                </div>
                <div className={WorkorderStyles.container}>
                     <Panel title={'workorders.start.titless'} defaultTitle={'Feedback Form'}>
                        <div className={WorkorderStyles.details}>
                            <div style={{ marginLeft: '75px' }}>
                                <h3>We value your experience.</h3>
                                <p>Please take a moment to share your feedback and help us serve you better.</p>
                            </div>
                            <div className={WorkorderStyles.details_form}>
                                {(leaseMaintenance_schema && leaseMaintenance_schema?.feedback_selection
                                && leaseMaintenance_schema.feedback_selection.label
                                && leaseMaintenance_schema.feedback_selection.label.toLowerCase() === 'rating') ? (
                                <div>
                                    {this.renderStarRating()}
                                    {ratingError && (
                                        <span style={{ color: 'red', fontSize: '14px' }}>{ratingError}</span>
                                    )}
                                </div>
                                ) : (
                                <>
                                    <div className={styles.fullInput}>
                                        <div className={styles.reactions}>
                                            <button className={`${styles.reviewBlock} ${info?.smiley === 1 ? styles.activeReview : ''}`}
                                                onClick={() => this.handleReview(1)}>
                                                <span role="img" aria-label="Awful" className={styles.review}>😡</span>Bad
                                            </button>
                                            <button className={`${styles.reviewBlock} ${info?.smiley === 2 ? styles.activeReview : ''}`}
                                                onClick={() => this.handleReview(2)}>
                                                <span role="img" aria-label="Poor" className={styles.review}>😒</span>Poor
                                            </button>
                                            <button className={`${styles.reviewBlock} ${info?.smiley === 3 ? styles.activeReview : ''}`}
                                                onClick={() => this.handleReview(3)}>
                                                <span role="img" aria-label="Neutral" className={styles.review}>😐</span>Neutral
                                            </button>
                                            <button className={`${styles.reviewBlock} ${info?.smiley === 4 ? styles.activeReview : ''}`}
                                                onClick={() => this.handleReview(4)}>
                                                <span role="img" aria-label="Good">🙂</span>Good
                                            </button>
                                            <button className={`${styles.reviewBlock} ${info?.smiley === 5 ? styles.activeReview : ''}`}
                                                onClick={() => this.handleReview(5)}>
                                                <span role="img" aria-label="Excellent">🤗</span>Excellent
                                            </button>
                                        </div>
                                        {ratingError && (
                                            <span style={{ color: 'red', fontSize: '14px' }}>{ratingError}</span>
                                        )}
                                    </div>
                                </>
                                )}

                                <Input
                                    type="textarea"
                                    name="comment"
                                    id="comment"
                                    value={info.comment}
                                    onChange={e => this.handleAnswerChanged('info', e.target.value, e.target.name)}
                                    placeholder="How can we improve? Share your feedback here..."
                                    style={{ height: '100px', marginTop: '20px' }}
                                    />
                                    {customFeedbackMessage && (
                                        <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>
                                            {customFeedbackMessage}
                                        </p>
                                    )}
                            </div>
                            <div className={WorkorderStyles.footer} style={{ justifyContent: 'center' }}>
                                <Button action="secondary" onClick={this.create}
                                    translationID="form.submit_formss"
                                    defaultText="Submit Your Feedback"
                                    className={WorkorderStyles.formButton}
                                />
                                <span>
                                    <a href="https://www.aerosimple.com" target="_blank" rel="noopener noreferrer" className={WorkorderStyles.formAnchor}>
                                    Powered by Aerosimple
                                    </a>
                                </span>
                            </div>
                        </div>
                     </Panel>
                </div>
                </>
                )}
                {apiStatus && (
                    <div className="container">
                        <FormSubmitted name={leaseMaintenance_schema && leaseMaintenance_schema.title}
                        message={message} logo={leaseMaintenance_schema?.airport_data?.image}
                        />
                    </div>
                )}
            </>
        );
    }
}


export default MaintenanceCreatePublic;
